import { type FC, type ReactNode } from "react";

import { type CofConfigId } from "../../gql-generated/types";
import { useFeatureGates } from "../hooks";

interface FeatureGuardProps {
    cofConfigId: CofConfigId;
    children?: ReactNode;
}

export const FeatureGuard: FC<FeatureGuardProps> = ({ cofConfigId, children }) => {
    const { configs } = useFeatureGates();

    if (configs[cofConfigId].enabled) {
        return <>{children}</>;
    }

    return null;
};
